import React,{Component} from 'react';
import Loading from '../Loading';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import InboxApi from '../../api/inbox';
import {connect} from 'react-redux';
import {showError} from '../../actions/uiActions';

class Email extends Component
{
    state={
        message:null,
        currentTab:0
    }
    componentDidMount()
    {
        InboxApi.getMessage(this.props.id,this.props.message._id).then(message=>this.setState({message},()=>this.props.onRead(this.state.message._id)),error=>{
            this.props.showError();
            this.props.onClose();
        }).catch(error=>{
            this.props.showError();
            this.props.onClose();
        });
    }
    render()
    {
        return <section className="padding animated fadeIn">
                
                <div className="row">
                <div className="col-12">
                </div>
                    <div className="col-6 offset-3">
                <div className="row">
                    <div className="col-4">
                        <b>Date Received:</b> 
                    </div>
                    <div className="col-8">
                        {this.props.message.date}
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <b>From:</b> 
                    </div>
                    <div className="col-8">
                        {this.props.message.from}
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <b>Subject:</b> 
                    </div>
                    <div className="col-8">
                        {this.props.message.subject}
                    </div>
                </div>
                <div className="line-break"></div>
                {!this.state.message&&<Loading />}
                {this.state.message&&<div>
                    <Tabs
        value={this.state.currentTab}
        onChange={(e,newValue)=>this.setState({currentTab:newValue})}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        <Tab label="HTML" />
        <Tab label="Plain" />
        {(this.state.message.attachments&&this.state.message.attachments.length>0)&&<Tab label="Attachments" />}
        </Tabs>
        <div className="line-break"></div>
        {this.state.currentTab===0&&<div dangerouslySetInnerHTML={{__html:this.state.message.html.replace(/\<a/,'<a target="_blank"')}} />}
        {this.state.currentTab===1&&<div>{this.state.message.text}</div>}
        {this.state.currentTab===2&&<ul className="attachments">
            {this.state.message.attachments.map((attachment,i)=><li key={i}>
                <a href={attachment.url} target="_blank" rel="noopener noreferrer">{attachment.file}</a>
            </li>)}
        </ul>}
                </div>}
                </div>
                </div>
                <div className="line-break"></div>
                <div className="text-center">
                    <button className="btn btn-standard btn-secondary" onClick={this.props.onClose}>Close</button>
                </div>
                <div className="line-break"></div>
            </section>
    }
}
export default connect(null,{showError})(Email);